<template>
  <div class="lost-page renedian-light-sand--background">

    <RippedHeader :breadcrumb="breadcrumb" :title="title" />
    
    <!-- Main content -->
    <div class="lost-content d-flex flex-column align-center justify-center">

      <span class="compass">
        <v-icon class="compass-icon" color="#2d271c">mdi-compass-rose</v-icon>
      </span>
      
      <!-- Title -->
      <h1 class="title barlow-condensed-bold renedian-sand-green--text text-uppercase">
        Trail Not Found
      </h1>
      
      <!-- Subtitle -->
      <p class="subtitle barlow-regular renedian-dark-brown--text text-center">
        Looks like you've ventured off the beaten path.<br class="d-none d-md-block">
        Even the best adventurers sometimes take a wrong turn.
      </p>

      <!-- Action buttons -->
      <div class="actions d-flex flex-column flex-md-row align-center justify-center mt-8">
        <button class="action-btn primary-btn barlow-condensed-bold" @click="goHome">
          <v-icon left color="white">mdi-home</v-icon>
          Return Home
        </button>
        <button class="action-btn secondary-btn barlow-condensed-bold" @click="exploreTours">
          <v-icon left color="#f26521">mdi-map-marker-path</v-icon>
          Explore Tours
        </button>
      </div>

      <!-- Helpful links -->
      <div class="helpful-links mt-12">
        <p class="links-title barlow-condensed-regular renedian-dark-sand--text text-uppercase">
          Popular Destinations
        </p>
        <div class="links-grid d-flex flex-wrap justify-center">
          <a @click="go('/adventure-motorcycle-tours/africa')" class="link-item barlow-regular">
            <v-icon small color="#b2703c">mdi-chevron-right</v-icon>
            Africa Tours
          </a>
          <a @click="go('/adventure-motorcycle-tours/south-america')" class="link-item barlow-regular">
            <v-icon small color="#b2703c">mdi-chevron-right</v-icon>
            South America
          </a>
          <a @click="go('/adventure-motorcycle-tours/mongolia')" class="link-item barlow-regular">
            <v-icon small color="#b2703c">mdi-chevron-right</v-icon>
            Mongolia
          </a>
          <a @click="go('/choosing-renedian')" class="link-item barlow-regular">
            <v-icon small color="#b2703c">mdi-chevron-right</v-icon>
            Why Renedian?
          </a>
          <a @click="go('/booking')" class="link-item barlow-regular">
            <v-icon small color="#b2703c">mdi-chevron-right</v-icon>
            Book Now
          </a>
        </div>
      </div>
    </div>


    <!-- Subtle background pattern -->
    <div class="background-overlay"></div>
  </div>
</template>

<script>
import RippedHeader from '@/components/RippedHeader.vue'
import prerenderReady from '@/mixins/prerenderReady'

export default {
  components: {
    RippedHeader
  },
  mixins: [prerenderReady],
  name: 'Lost',
  data() {
    return {
      // breadcrumb: 'Renedian / Lost',
      // title: 'Page Not Found',
    }
  },
  methods: {
    goHome() {
      this.go('/')
    },
    exploreTours() {
      this.go('/adventure-motorcycle-tours/africa')
    }
  },
  mounted() {
    // Update page meta
    document.title = 'Page Not Found | Renedian'
    const descriptionTag = document.querySelector('meta[name="description"]')
    if (descriptionTag) {
      descriptionTag.setAttribute('content', 'The page you are looking for could not be found. Explore our adventure motorcycle tours instead.')
    }
  }
}
</script>

<style lang="scss" scoped>
.lost-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

.lost-content {
  margin: 100px auto 150px auto;
  padding: 0 20px;
}

.background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Fpatterns%2Ftopography-subtle.png?alt=media');
  background-repeat: repeat;
  opacity: 0.03;
  pointer-events: none;
  z-index: 0;
}

.top-section {
  position: relative;
  z-index: 1;
  background: #f5f0e8;
  
  .torn-edge {
    display: block;
    margin-bottom: -1px;
  }
}

.hero-section {
  position: relative;
  z-index: 1;
  padding: 40px 20px 60px;
  text-align: center;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  @media (min-width: 960px) {
    padding: 60px 40px 80px;
  }
}

.compass {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  
  .compass-icon {
    font-size: clamp(80px, 15vw, 140px) !important;
    opacity: 0.9;
    margin-bottom: 20px;
  }
}

.error-code {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  
  .four {
    font-size: clamp(80px, 15vw, 180px);
    color: #f26521;
    text-shadow: 4px 4px 0px rgba(0, 0, 0, 0.1);
    line-height: 1;
  }
}

@keyframes spin-slow {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

h1.title {
  font-size: clamp(28px, 5vw, 42px) !important;
  margin-bottom: 16px;
  letter-spacing: 3px !important;
  font-weight: 700 !important;
}

.subtitle {
  font-size: clamp(16px, 2.5vw, 20px);
  max-width: 600px;
  line-height: 1.6;
  opacity: 0.85;
}

.actions {
  gap: 16px;
  
  @media (min-width: 960px) {
    gap: 24px;
  }
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 32px;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 220px;
  
  @media (min-width: 960px) {
    font-size: 18px;
    padding: 16px 40px;
  }
  
  &.primary-btn {
    background: linear-gradient(135deg, #f26521 0%, #d95419 100%);
    color: white;
    box-shadow: 0 4px 15px rgba(242, 101, 33, 0.3);
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(242, 101, 33, 0.4);
    }
  }
  
  &.secondary-btn {
    background: transparent;
    color: #f26521;
    border: 2px solid #f26521;
    
    &:hover {
      background: rgba(242, 101, 33, 0.08);
      transform: translateY(-2px);
    }
  }
}

.helpful-links {
  max-width: 700px;
  
  .links-title {
    font-size: 14px;
    letter-spacing: 2px;
    margin-bottom: 16px;
  }
  
  .links-grid {
    gap: 8px 24px;
  }
  
  .link-item {
    display: flex;
    align-items: center;
    color: #5a6660;
    text-decoration: none;
    font-size: 15px;
    padding: 6px 0;
    cursor: pointer;
    transition: color 0.2s ease;
    
    &:hover {
      color: #f26521;
    }
    
    .v-icon {
      margin-right: 4px;
    }
  }
}

.bottom-section {
  position: relative;
  z-index: 1;
  background: #ebe4d8;
  
  .torn-edge-bottom {
    display: block;
    transform: scaleY(-1);
  }
}
</style>
